import React from "react";
import {Container} from "react-bootstrap";
import NutzungLayout from "../../Components/Nutzung/NutzungLayout.jsx";
import useNutzungFilter from "../../Components/Nutzung/useNutzungFilter.js";
import useStatisticsData from "../../Components/Statistics/useStatisticsData.js";
import NutzungFunktionenTabelle from "../../Components/Nutzung/NutzungFunktionenTabelle.jsx";

/**
 * Meistgenutzte Seiten und Funktionen (Auftrag Teil 3) - ersetzt inhaltlich
 * die frühere Funktionen.jsx (jetzt nur noch Umleitung, siehe web.php
 * /nutzung/funktionen -> /nutzung/seiten). Nutzt denselben bestehenden
 * Endpunkt /nutzung/daten/funktionen wie zuvor und dieselbe Tabelle
 * (NutzungFunktionenTabelle) - hier bewusst OHNE den Block "Von niemandem
 * benutzt", der jetzt eine eigene Seite ist (Ungenutzt.jsx).
 */
export default function NutzungSeiten() {
    const nutzungFilters = useNutzungFilter();
    const {filters} = nutzungFilters;
    const {data, loading, error} = useStatisticsData("/nutzung/daten/funktionen", filters);

    return (
        <Container fluid className="pt-2 pb-4">
            <NutzungLayout gruppe="Seiten" titel="Meistgenutzte Seiten" nutzungFilters={nutzungFilters}>
                <NutzungFunktionenTabelle genutzt={data?.genutzt} loading={loading} error={error} />
            </NutzungLayout>
        </Container>
    );
}
